export default defineNuxtRouteMiddleware((to, from) => {
	const isDev = process.env.DEV === true;
	if (isDev) {
		navigateTo(to);
	} else {
		return;
	}
})